export const licenseKey = () => {
  return 'FileInvite Limited:OEM:FileInvite Limited::B+:AMS(20250304):C7DC3F0C074A2AF37B313AC9B24338264E6F7FC98B46E08D4215591C1C00F65AAAB6F5C7';
};

export const portalNutrientKey = () => {
  return process.env['NX_PUBLIC_NUTRIENT_PORTAL_KEY'];
};

export const portalDAKOTABUSINESSNutrientKey = () => {
  return process.env['NX_PUBLIC_NUTRIENT_PORTAL_DAKOTABUSINESS_KEY'];
};

export const appNutrientKey = () => {
  return process.env['NX_PUBLIC_NUTRIENT_APP_KEY'];
};

export function customEncode(key: string) {
  const modifiedKey = key
    .split('')
    .map((char) => char + '*')
    .join('');
  return window.btoa(modifiedKey);
}

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $zfeg48: any;
    $xr9c42: any;
    $rw39c6: any;
    $dk1004: any;
  }
}

window.$zfeg48 = customEncode(licenseKey());
window.$xr9c42 = customEncode(appNutrientKey() ?? '');
window.$rw39c6 = customEncode(portalNutrientKey() ?? '');
window.$dk1004 = customEncode(portalDAKOTABUSINESSNutrientKey() ?? '');

export function customDecode(encodedKey: string) {
  const decodedKey = window.atob(encodedKey);
  return decodedKey
    .split('')
    .filter((_, index) => index % 2 === 0)
    .join('');
}
